export enum ResponsiveCalendarHeaderToolbarElement {
  Title = 'title',
  Prev = 'prev',
  Next = 'next',
  Today = 'today',
}
